import PrimaryButton from "features/shared/components/buttons/PrimaryButton.styled";
import styled from "styled-components";

const PaxErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px 16px;

  ${PrimaryButton} {
    margin-top: 24px;
  }
`;

export default PaxErrorContainer;
